import Datepicker from "./Datepicker";

/**
 * This plugin is used for future and historical appointments
 * it is imported by Appointments.js
 */
export default class AppointmentList {

    // constructor
    constructor(selector) {
        this.$plugin = $(selector);
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }

        let vm = this;
        this.$filter = $plugin.find('[data-tncp-resultfilter="filter"]');
        this.$result = $plugin.find('[data-tncp-resultfilter="results"]');
        this.loadFilterSettings();

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-showsection-toggle]', function () {
            let $toggle = $(this);
            $plugin.find('[data-tncp-showsection-toggle]').show();
            $toggle.hide();
            $plugin.find('[data-tncp-showsection]').attr('data-tncp-showsection', $toggle.data('tncpShowsectionToggle'));
            return false;
        });

        // advanced filter toggle
        $plugin.on('change', '[data-tncp-plugin-additionalappointmentsfilter="listen"]', function () {
            let $watchElement = $plugin.find('[data-tncp-plugin-additionalappointmentsfilter="watch"]');
            $watchElement.find('input').val('');
            if ($(this).val() === 'customRange') {
                $watchElement.show();
            } else {
                $watchElement.hide();
            }
            return false;
        });
    }

    // load filter settings
    loadFilterSettings() {
        let vm = this;
        const filterSettingsUrl = vm.$plugin.find('[data-tncp-resultfilter-filtersettings-xhr]').attr('data-tncp-resultfilter-filtersettings-xhr');
        vm.request = window.xhrRequest({
            url: filterSettingsUrl,
            method: 'GET',
        });
        vm.request.then((response) => {
            vm.$filter.html(response.data.content);
            vm.execute();
            new Datepicker(vm.$plugin.selector);

            vm.$filter.find('input[type="text"]').on('keypress', function (e) {
                if (e.key === 'Enter') {
                    event.preventDefault();
                    vm.$filter.find('[data-tncp-resultfilter="filterForm"]').submit();
                }
            });
        });
    }

    // execute
    execute() {
        let vm = this;
        // on page load
        vm.getResults();

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-resultfilter="filterForm"]', () => {
            vm.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
            vm.getResults();
            return false;
        });

        // on show more click
        vm.$plugin.on('click', '[data-showmore="trigger"]', function() {
            let $thisTrigger = $(this);
            let $contentContainer = $thisTrigger.closest('[data-showmore="container"]');
            let $detailBoxContent = $contentContainer.find('[data-showmore="content"]');
            if ($detailBoxContent.hasClass('c-seminar-entry__detailbox--active')) {
                $detailBoxContent.removeClass('c-seminar-entry__detailbox--active');
                $thisTrigger.attr('data-icon', 'ui_arrow_down');
            } else {
                $detailBoxContent.addClass('c-seminar-entry__detailbox--active');
                $thisTrigger.attr('data-icon', 'ui_arrow_up');
            }
            return false;
        });

    }

    // get results
    getResults() {
        let vm = this;
        return new Promise(function(resolve, reject) {
            let $form = vm.$plugin.find('[data-tncp-resultfilter="filterForm"]');

            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');
            let serializedFilters = $form.serialize();
            vm.disableForm($form);

            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: serializedFilters
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);
                vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');
                vm.disableForm($form, false);

                // Init / reinit Sticky timeline
                var $stickyTimeline = vm.$plugin.find('.js-timeline__sticky');
                $stickyTimeline.css('width', $stickyTimeline.parent().width()).fixedsticky();
                $(window).resize(function() {
                    $stickyTimeline.css('width', $stickyTimeline.parent().width());
                });

                $(document).find('[data-anchor]').on('click',function(e) {
                    var $target = $(this).data('anchor');
                    $('html, body').stop().animate({
                        'scrollTop': $(document).find('[data-anchor-target="'+ $target + '"]').offset().top
                    }, 900, 'swing', function () {

                    });
                });

                vm.$plugin.find('.fixedsticky-dummy').css('display', 'none');

                resolve(response);
            }).catch((e) => {
                reject(e);
            });
        });
    }

    // disable form
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

}